import React from 'react'
import Base from './Base'

export default props => (
  <Base {...props} viewBox='0 0 100 100'>
    <path d='M50,18A32,32,0,1,0,82,50,32,32,0,0,0,50,18Zm0,50a4,4,0,1,1,4-4A4,4,0,0,1,50,68Zm4-14H46V32h8Z' />
  </Base>
)
